<div class="fullcontainer pr-3">
  <div class='sheet'>
    <div class='titleContainer'>
      <h1 class='header'>Report - Jobs</h1>
    </div>

    <div class='row'>
      <div class='col-md-4'>
        <label>Start Date</label>
        <input type='date' [(ngModel)]="this.searchFilters.startDate" class='form-control' />
      </div>
      <div class='col-md-4'>
        <label>End Date</label>
        <input type='date' class='form-control' [(ngModel)]="this.searchFilters.endDate" />
      </div>
      <div class='col-md-4'>
        <label>Customer</label>
        <ng-select [(ngModel)]="this.searchFilters.customer" (change)='this.searchFilters.customer = $event;'>
          @for (item of this.accounts; track item) {
            <ng-option [value]='item.name'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Site</label>
        <input type='text' class='form-control' [(ngModel)]="this.searchFilters.site"/>
      </div>
      <div class='col-md-4'>
        <label>Tip Site</label>
        <input type='text' class='form-control' [(ngModel)]="this.searchFilters.tipSite"/>
      </div>
      <div class='col-md-4'>
        <label>Vehicle</label>
        <ng-select [(ngModel)]="this.searchFilters.vehicle" (change)='this.searchFilters.vehicle = $event;'>
          @for (item of this.vehicles; track item) {
            <ng-option [value]='item.registration'>{{ item.registration }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Driver</label>
        <ng-select [(ngModel)]="this.searchFilters.driver" (change)='this.searchFilters.driver = +$event;'>
          @for (item of this.drivers; track item) {
            <ng-option [value]='item.id'>{{ item.firstName }} {{ item.lastName }}</ng-option>
          }
        </ng-select>
      </div>
      <div class='col-md-4'>
        <label>Subcontractor</label>
        <input type='text' class='form-control' [(ngModel)]="this.searchFilters.subcontractor"/>
      </div>
      <div class='col-md-4'>
        <label>Parent Job ID</label>
        <input type='text' class='form-control' [(ngModel)]="this.searchFilters.orderRef"/>
      </div>
    </div>
    <br />
    <br />
    <button class='btn btn-primary' (click)='this.loadReport()'>Run Report</button>
    <hr />
    <button class='btn btn-secondary' (click)='exportToCSV()'>Export to CSV</button>
  </div>

  <div class='sheet'>
    @if (this.jobs.length > 0) {
      <div class='titleContainer'>
        <h1 class='header'>Results</h1>
        <table class='table'>
          <thead>
            <th>Job ID</th>
            <th>Parent Job ID</th>
            <th>Customer</th>
            <th>Site</th>
            <th>Tip Site</th>
            <th>Qty</th>
            <th>Date</th>
            <th>Vehicle</th>
            <th>Driver</th>
            <th>Subcontractor</th>
            <th></th>
          </thead>
          <tbody>
            @for (job of this.jobs; track job) {
              <tr>
                <td>{{ job.id }}</td>
                <td>{{ job.order.id }}</td>
                <td>{{ job.order.account.name }}</td>
                <td>{{ job.order.site.name }}</td>
                <td>{{ job.order.tipSite.name }}</td>
                <td>{{ job.qty }}</td>
                <td>{{ job.date }}</td>
                <td>{{ !job.jobAssignment.vehicle ? 'N/A' : job.jobAssignment.vehicle.registration }}</td>
                @if (job.jobAssignment.driver) {
                  <td>{{ job.jobAssignment.driver.firstName }} {{ job.jobAssignment.driver.lastName }}</td>
                }
                @if (!job.jobAssignment.driver) {
                  <td>N/A</td>
                }
                <td>{{ !job.jobAssignment.subcontractor ? 'N/A' : job.jobAssignment.subcontractor.name }}</td>
                <td><button class='btn btn-warning' [routerLink]='"/orders/edit/" + job.order.id'>View Order</button><button class='btn btn-warning' [routerLink]='"/job-signoff/land/view/" + job.id'>View job</button>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>